import {
  HELP_CENTER_URL,
  JP_HELP_CENTER_URL,
  USER_OPTIONS_MENU_ITEM_SIGN_OUT,
} from '../constants/constants';

export const JAPAN_LOCALE_STRING = 'jp';
const JAPAN_SITE_LIVE_URL = 'https://www.bloomberg.co.jp/live';
const DEFAULT_LIVE_URL = '/live';

export { default as labelIds } from './label_ids.json';
export const contextId = 4713;

export function getLiveUrl(locale?: string): string {
  if (locale === JAPAN_LOCALE_STRING) {
    return JAPAN_SITE_LIVE_URL;
  }

  return DEFAULT_LIVE_URL;
}

export function getHelpCenterUrl(locale?: string): string {
  if (locale === JAPAN_LOCALE_STRING) {
    return JP_HELP_CENTER_URL;
  }

  return HELP_CENTER_URL;
}

/**
 * Localizes a URL based on the provided locale.
 * For JP locale, prefixes the URL with /jp/ (except for sign-out URL).
 * For all other locales, returns the URL unchanged.
 *
 * @param locale - The locale string (e.g., 'en', 'jp')
 * @param url - The URL to localize
 * @returns The localized URL
 */
export function localizeUrl(locale: string, url: string): string {
  if (
    locale === JAPAN_LOCALE_STRING &&
    url !== USER_OPTIONS_MENU_ITEM_SIGN_OUT.url
  ) {
    return `/${JAPAN_LOCALE_STRING}/${url.replace(/^\//, '')}`;
  }

  return url;
}
